import React, { useEffect, useState } from "react";
import Sidebar from "../../../layouts/sidebar";
import Headers from "../../../layouts/header";
import Select from "react-select";
import { toast } from "react-toastify";
import { Nav, Tab, Row, Col, Toast } from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-datetime/css/react-datetime.css";

import { useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router";
import { DecryptData, ImgEmpty, NumberChange, NumberOnly, isEmpty } from "../../../actions/common";
import useAxiosFile from "../../../actions/useaxios";
import config from "../../../actions/config";

const initname = {
  CouponTitle: "",
  CouponDescription: "",
  CouponCode: "",
  ShopId: [],
  CouponType: "", // CouponType - 1st order , BuyGet , Discount ,Cashback
  // For: "",// product - all,particular
  BuyProductId: ["All"],
  GetProductId: ["All"],
  Expiry: "All",
  Day: ["All"],
  StartTime: "",
  ExpireTime: "",
  // UserId: [],
  DiscountValue: "", //price/percentage
  Value: "",
  Max: 0,
  Min: "",
  Creator: "",
  CouponImage: "",
};

const CouponTypeOptions = [
  // { value: "BuyGet", label: "Buy Get" },
  { value: "Discount", label: "Discount" },
  { value: "Price", label: "Price" },
];

const couponsTypeoption = [
  { value: "1storder", label: "Default" },
  // { value: "buyget", label: "Buy Get" },
  { value: "above", label: "Flat Deal" },
];

const PriceOption = [
  { label: "Percentage", value: "percentage" },
  { label: "Price", value: "price" },
];
const TimeOPtion = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Time",
    value: "time",
  },
  {
    label: "Day",
    value: "day",
  },
];
const Days = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Sunday",
    value: "sunday",
  },
  {
    label: "Tuesday",
    value: "tuesday",
  },
  {
    label: "Wednesday",
    value: "wednesday",
  },
  {
    label: "Thursday",
    value: "thursday",
  },
  {
    label: "Friday",
    value: "friday",
  },
  {
    label: "Saturday",
    value: "saturday",
  },
];

function Coupons() {
  const location = useLocation();
  const navigate = useNavigate();

  const axiosFile = useAxiosFile();
  console.log(
    "adsdsdefsdefg",
    location.search,
    location.search.split("?Id=")[1],
    DecryptData(location.search.split("?Id=")[1])
  );
  const [Id, Setid] = useState(DecryptData(location.search.split("?Id=")[1])?.Id);
  const [action, setaction] = useState(DecryptData(location.search.split("?Id=")[1])?.action);
  const [Error, SetError] = useState({});
  const [Formdata, SetFormdata] = useState(initname);
  console.log("formatsdate", Formdata);
  const [AllProduct, SetAllProduct] = useState([]);
  const [AllShops, setAllShops] = useState([]);
  const [User, SetUser] = useState('ALL')
  console.log("Allshopsss", AllShops);
  const [shopdata, setshopdata] = useState();
  console.log("shopalls_data", shopdata);
  useEffect(() => {
    getShop();
    //  getProduct()
  }, []);

  useEffect(() => {
    getCurrentCoupon()
  }, [Id, location?.search, action]);
  useEffect(() => {
    // getShop()
    getProduct();
  }, [Formdata?.ShopId]);
  console.log("sdahfjhshfjksd", Formdata);


  const getCurrentCoupon = async () => {

    var Resp = await axiosFile.getCouponList({ _id: Id, action: "all" });
    console.log("RespRespResp", Resp)
    SetFormdata({
      ...Formdata, ...Resp.data,
      StartTime: convertToLocal(Resp.data?.StartTime),
      ExpireTime: convertToLocal(Resp.data?.ExpireTime),
    });
    
  };

  const convertToLocal = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
  };
  console.log("________________________", Formdata)

  const getProduct = async () => {
    if (Array.isArray(Formdata?.ShopId) && Formdata?.ShopId?.length > 0 && Formdata?.ShopId.some((id) => id != "All")) {
      var Resp = await axiosFile.getProduct({ ShopId: Formdata?.ShopId });
    } else {
      var Resp = [];
    }
    SetAllProduct([{ label: "All", value: "All" }, ...Resp]);
  };

  //shoplist
  const getShop = async () => {
    var resp = await axiosFile.getShoplist();

    // setAllShops([...[{ value: "All", label: "All" }], ...shopdatalist])
    setshopdata([...[{ value: "All", label: "All" }], ...resp]);
  };

  console.log("alllshopss", shopdata);

  const onchangeshop = async (e) => {
    console.log("eee", e);
    SetError({});

    let ShopsList = [];
    // var formdata = Formdata
    // console.log("sdfergerth",e[e.length - 1 ].value=='All');
    if (e?.[e?.length - 1]?.value == "All") {
      console.log("sdsdasdfdf");
      // AllShops.map((val, i) => {

      // ShopId.push("All");
      // });

      SetFormdata({
        ...Formdata,
        ...{ ["ShopsList"]: ["All"] },
      });
      // formdata.ShopId=["All"]
      // SetFormdata(formdata)
      // console.log();
    } else {
      e.map((val, i) => {
        ShopsList.push(val.value);
      });
      // console.log("shopidddd",ShopId.filter((shops)=>(  shops != "All" )));
      // if(ShopId)
      SetFormdata({
        ...Formdata,
        ...{ ["ShopsList"]: ShopsList.filter((shops) => shops != "All") },
      });
    }

    // console.log("ShopIdShopId",ShopId);
  };


  const { toggle } = useSelector((state) => state.admin_panel.User);

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid lightgray",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const OnChange = (e, ids, multi) => {
    SetError({});

    var { id, value, files, label } = e.target ?? e;
    id = id ?? ids;
    let numcheckkeys = ["Max", "Value"]
    console.log("jn", id, value, files, ids, multi, Formdata?.[id]);
    if (multi) {
      SetFormdata({
        ...Formdata,
        ...{
          [id]:
            e.length > 1 && e.some((id) => id.value == "All")
              ? [...e.filter((it) => it.value == "All").map((id) => id.value)]
              : [...e.map((it) => it.value)],
        },
      });
    } else {
      if (files?.length > 0) {
        if (!files?.[0]?.type?.includes("image")) {
          return toast.error("Upload Images Only", 1000);
        }
      }
      SetFormdata({
        ...Formdata,
        ...{
          [id]: files?.length > 0 ? files[0] : (numcheckkeys.includes(id) ? NumberOnly(value) : value),
        },
      });
    }
    // }
  };

  const Validation = () => {
    console.log("jjuhju", Formdata);
    var errors = {};
    var NumONly = /^\d+$/;
    if (isEmpty(Formdata.CouponTitle))
      errors.CouponTitle = "CouponTitle is required";
    if (isEmpty(Formdata.CouponCode))
      errors.CouponCode = "CouponCode is required";
    if (isEmpty(Formdata.CouponType))
      errors.CouponType = "CouponType is required";
    // if (isEmpty(Formdata.CouponImage?.type) || (Id && isEmpty(typeof Formdata?.CouponImage == "object" ? Formdata?.CouponImage?.type:Formdata?.CouponImage)))
    //   errors.CouponImage = "CouponImage is required";
    if (isEmpty(Formdata.ShopId))
      errors.ShopId = "ShopId is required";
    if (!isEmpty(Formdata.CouponType) && (Formdata.CouponType == "above") && isEmpty(Formdata?.Value)) {
      errors.Value = "Value is required";
    }
    if (!isEmpty(Formdata.CouponType) && ((Formdata.CouponType == "above") || !isEmpty(Formdata?.Max) || !isEmpty(Formdata?.Value))) {
      if (isEmpty(Formdata?.Max)) {
        errors.Max = "Value is required";
      }
      if (!isEmpty(Formdata?.Max)) {
        if ((NumberChange(Formdata?.Value) >= NumberChange(Formdata?.Max))) {
          errors.Value = ("Value must be less than Above Value ");
          errors.Max = ("Above Value must be less than Value ");
        }
      }
      if (isEmpty(Formdata?.DiscountValue)) {
        errors.DiscountValue = "Type is required";
      }
    }
    if (!isEmpty(Formdata.Expiry) && Formdata.Expiry == "time" && isEmpty(Formdata?.StartTime))
      errors.StartTime = "Start Time is required";

    if (!isEmpty(Formdata.Expiry) && Formdata.Expiry == "time" && isEmpty(Formdata?.ExpireTime))
      errors.ExpireTime = "Expire Time is required";

    if (!isEmpty(Formdata.CouponType) && Formdata.CouponType == "above" && !isEmpty(Formdata?.Value) && !isEmpty(Formdata?.Max) && (Number(Formdata?.Value) >= Number(Formdata?.Max)))
      errors.Value = "Value should be less than Above Value";

    if (!isEmpty(Formdata.Expiry) && Formdata.Expiry == "day" && isEmpty(Formdata?.Day))
      errors.Day = "Days is required";

    return errors;
  };
  console.log("********************", Formdata)
  const Submit = async () => {
    // let id = LoadToast()

    let validate = Validation();
    console.log("iuy", validate, isEmpty(validate));

    if (isEmpty(validate)) {
      let senddata = Formdata;
      senddata._id = Id
      senddata.action = action ? action : "add";
      senddata.ShopId = JSON.stringify(Formdata?.ShopId)
      senddata.BuyProductId = JSON.stringify(Formdata?.BuyProductId)
      senddata.GetProductId = JSON.stringify(Formdata?.GetProductId)
      senddata.UserId = JSON.stringify(Formdata?.UserId)
      senddata.Day = JSON.stringify(Formdata?.Day)
      senddata.approve = Formdata?.CouponType == "1storder" ? true : false
      console.log("senddatasenddatasenddatasenddata", senddata)
      let Resp = await axiosFile.getCouponList(senddata);

      if (Resp?.success == "success") {
        navigate("/couponslist", { state: senddata });
        toast.success((Id ? "Updated" : "Added") + " Successfully", 1000);
      } else {
        toast.error(Resp?.msg ?? "Try-Again", 1000);
        SetError(Resp?.error);
      }
    } else {
      // updateToast(id, "fix all validation", "error")

      SetError(validate);
      toast.error("Fix all Validations", 1000);
    }
  };




  async function SendNotification() {
    let Resp = await axiosFile.SendNotification({ User, _id: Id });

    if (Resp?.success == "success") {
      navigate("/couponslist");
      toast.success("Added Successfully", 1000);
    } else {
      toast.error("Try-Again", 1000);
    }
  }


  return (
    <>
      {
        action == "send" ?
          <section id="content-wrapper">
            <div class="row">
              <div className="top_title_sec">
                <div>
                  <p className="page_title">{"Send Coupons"}</p>
                </div>
              </div>
            </div>
            {/* profile details */}
            <div className="mt-4">
              <div className="mdv_profiledtls">
                <Row className="mdv_inputrow">
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Users</p>
                    <input
                      className="mdv_cmninput"
                      type="text"
                      placeholder="Enter Email-Id / ALL"
                      id="Value"
                      // value={Formdata.Value || ""}
                      onChange={(e) => SetUser(e?.target?.value)}
                    />
                    {/* {Error?.Value && (
                                  <span className="error-msg">
                                    {Error?.Value}
                                  </span>
                                )} */}

                    <p>If you want send coupon to all users type "ALL" in input field or Enter Email Id.</p>
                  </Col>

                  <div className="mdv_update_dualbtn">
                    <button
                      className="blue_btn mdv_update"
                      type="button"
                      onClick={() => SendNotification()}
                    >
                      Send
                    </button>

                  </div>
                </Row>
              </div>
            </div>

            {/* end of change password details */}
          </section> :
          <section id="content-wrapper">
            <div class="row">
              <div className="top_title_sec">
                <div>
                  <p className="page_title">{(Id ? "Edit" : "Add") + " Coupons"}</p>
                </div>
              </div>
            </div>
            {/* profile details */}
            <div className="mt-4">
              <div className="mdv_profiledtls">
                <Row className="mdv_inputrow">
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Coupon Title</p>
                    <input
                      className="mdv_cmninput"
                      type="text"
                      placeholder="John"
                      id="CouponTitle"
                      value={Formdata?.CouponTitle}
                      // disabled={Formdata?.title}
                      onChange={(e) => OnChange(e)}
                    />
                    {Error?.CouponTitle && (
                      <span className="error-msg">
                        {Error?.CouponTitle}
                      </span>
                    )}
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Description</p>
                    <input
                      className="mdv_cmninput"
                      type="text"
                      placeholder="John"
                      value={Formdata?.CouponDescription || ""}
                      // disabled={Formdata?.CouponDescription}
                      id="CouponDescription"
                      onChange={(e) => OnChange(e)}
                    />
                    {Error?.CouponDescription && (
                      <span className="error-msg">
                        {Error?.CouponDescription}
                      </span>
                    )}
                  </Col>

                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Coupon Code</p>
                    {/* <input className='mdv_cmninput' type="email" placeholder="john@jamkse.com"/> */}

                    <input
                      className="mdv_cmninput"
                      type="text"
                      placeholder="Offer Codes"
                      id="CouponCode"
                      value={Formdata.CouponCode}
                      onChange={(e) => OnChange(e)}
                      maxLength={15}
                    />

                    {Error?.CouponCode && (
                      <span className="error-msg">
                        {Error?.CouponCode}
                      </span>
                    )}
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Coupon Type</p>
                    <Select
                      options={couponsTypeoption}
                      styles={stylesgraybg}
                      onChange={(e) => OnChange(e, "CouponType")}
                      className="border_blue_select"
                      classNamePrefix="react-select"
                      placeholder="Select Options"
                      value={
                        Formdata?.CouponType
                          ? {
                            label: couponsTypeoption.find(
                              (id) =>
                                id.value == Formdata?.CouponType
                            )?.label,
                            value: Formdata?.CouponType,
                          }
                          : ""
                      }
                    />

                    {Error?.CouponType && (
                      <span className="error-msg">
                        {Error?.CouponType}
                      </span>
                    )}
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Shop Id</p>
                    <Select
                      isMulti
                      options={Formdata?.CouponType == "above" ? shopdata?.filter(it => it.value != "All") : shopdata}
                      styles={stylesgraybg}
                      className="border_blue_select"
                      classNamePrefix="react-select"
                      placeholder="Select Options"
                      onChange={(e) => OnChange(e, "ShopId", true)}
                      value={

                        (Array.isArray(Formdata?.ShopId) && Formdata?.ShopId?.length > 0) ?
                          Formdata?.ShopId?.map((it) => {
                            return {
                              label: shopdata?.find(
                                (id) => id.value == it
                              )?.label,
                              value: it,
                            };
                          })
                          :
                          []
                      }

                    // disabled={Formdata.CouponType}
                    />
                    {console.log("______________", Formdata)}

                    {Error?.ShopId && (
                      <span className="error-msg">
                        {Error?.ShopId}
                      </span>
                    )}
                  </Col>


                  {["1storder", "buyget", "above"]?.includes(
                    Formdata?.CouponType
                  ) && (
                      <Col
                        xxl={4}
                        xl={4}
                        lg={4}
                        md={6}
                        sm={6}
                        xs={12}
                        className="mb-3"
                      >
                        <p className="mdv_inplabel">Buy Product Id</p>
                        <Select
                          isMulti
                          options={AllProduct}
                          styles={stylesgraybg}
                          className="border_blue_select"
                          classNamePrefix="react-select"
                          placeholder="Select Options"
                          onChange={(e) =>
                            OnChange(e, "BuyProductId", true)
                          }
                          value={
                            ((Array.isArray(Formdata?.BuyProductId) && Formdata?.BuyProductId?.length > 0) ?
                              Formdata?.BuyProductId.map((it) => {
                                return {
                                  label: AllProduct?.find(
                                    (id) => id.value == it
                                  )?.label,
                                  value: it,
                                };
                              })
                              :
                              [])
                          }
                        />

                        {Error?.BuyProductId && (
                          <span className="error-msg">
                            {Error?.BuyProductId}
                          </span>
                        )}
                      </Col>
                    )}
                  {["buyget"]?.includes(Formdata?.CouponType) && (
                    <Col
                      xxl={4}
                      xl={4}
                      lg={4}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-3"
                    >
                      <p className="mdv_inplabel">Get Product Id</p>
                      <Select
                        isMulti
                        options={AllProduct}
                        styles={stylesgraybg}
                        onChange={(e) => OnChange(e, "GetProductId")}
                        className="border_blue_select"
                        classNamePrefix="react-select"
                        placeholder="Select Options"
                        value={
                          Formdata.GetProductId
                            ? {
                              label: AllProduct?.find(
                                (ig) =>
                                  ig.value == Formdata.GetProductId
                              )?.label,
                              value: Formdata.GetProductId,
                            }
                            : ""
                        }
                      // disabled={Formdata.CouponType}
                      />

                      {Error?.GetProductId && (
                        <span className="error-msg">
                          {Error?.GetProductId}
                        </span>
                      )}
                    </Col>
                  )}
                  {["above", "1storder"]?.includes(
                    Formdata?.CouponType
                  ) && (
                      <Col
                        xxl={4}
                        xl={4}
                        lg={4}
                        md={6}
                        sm={6}
                        xs={12}
                        className="mb-3"
                      >
                        <p className="mdv_inplabel">Value</p>
                        <input
                          className="mdv_cmninput"
                          type="text"
                          placeholder="Enter Value"
                          id="Value"
                          value={Formdata.Value || ""}
                          onChange={(e) => OnChange(e)}
                        />
                        {Error?.Value && (
                          <span className="error-msg">
                            {Error?.Value}
                          </span>
                        )}
                      </Col>
                    )}
                  {["above", '1storder']?.includes(Formdata?.CouponType) && (
                    <Col
                      xxl={4}
                      xl={4}
                      lg={4}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-3"
                    >
                      <p className="mdv_inplabel">Above Value</p>
                      <input
                        className="mdv_cmninput"
                        type="text"
                        placeholder="Enter Above Value"
                        id="Max"
                        value={Formdata.Max || ""}
                        onChange={(e) => OnChange(e)}
                      />
                      {Error?.Max && (
                        <span className="error-msg">
                          {Error?.Max}
                        </span>
                      )}
                    </Col>
                  )}
                  {["above", '1storder']?.includes(
                    Formdata?.CouponType
                  ) && (
                      <Col
                        xxl={4}
                        xl={4}
                        lg={4}
                        md={6}
                        sm={6}
                        xs={12}
                        className="mb-3"
                      >
                        <p className="mdv_inplabel">Price/Percentage</p>
                        <Select
                          options={PriceOption}
                          styles={stylesgraybg}
                          onChange={(e) => OnChange(e, "DiscountValue")}
                          className="border_blue_select"
                          classNamePrefix="react-select"
                          placeholder="Select Options"
                          value={
                            Formdata.DiscountValue
                              ? {
                                label: PriceOption?.find(
                                  (ig) =>
                                    ig.value == Formdata.DiscountValue
                                )?.label,
                                value: Formdata.DiscountValue,
                              }
                              : ""
                          }
                        // disabled={Formdata.CouponType}
                        />

                        {Error?.DiscountValue && (
                          <span className="error-msg">
                            {Error?.DiscountValue}
                          </span>
                        )}
                      </Col>
                    )}

                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel"> Expiry </p>
                    <Select
                      // isMulti
                      options={TimeOPtion}
                      styles={stylesgraybg}
                      value={{
                        value: Formdata?.Expiry,
                        label: TimeOPtion.find(
                          (is) => is.value == Formdata?.Expiry
                        )?.label,
                      }}
                      onChange={(e) => {
                        OnChange(e, "Expiry");
                      }}
                      className="border_blue_select"
                      classNamePrefix="react-select"
                      placeholder="A...."

                    // disabled={Formdata.BuyProductId.length>0}
                    />

                    {Error?.Expiry && (
                      <span className="error-msg">
                        {Error?.Expiry}
                      </span>
                    )}
                  </Col>

                  {Formdata?.Expiry == "time" && (
                    <Col
                      xxl={4}
                      xl={4}
                      lg={4}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-3"
                    >
                      <p className="mdv_inplabel">Start Time</p>
                      <input
                        className="mdv_cmninput"
                        type="datetime-local"
                        min={new Date().toISOString().slice(0, -8)}
                        placeholder="Doe"
                        value={Formdata.StartTime ? Formdata.StartTime.slice(0, 16) : ""}
                        // disabled={Formdata.StartTime}
                        id="StartTime"
                        onChange={(e) => OnChange(e)}
                      />
                      {Error?.StartTime && (
                        <span className="error-msg">
                          {Error?.StartTime}
                        </span>
                      )}
                    </Col>
                  )}

                  {Formdata?.Expiry == "time" && (
                    <Col
                      xxl={4}
                      xl={4}
                      lg={4}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-3"
                    >
                      <p className="mdv_inplabel">End Time</p>
                      <input
                        className="mdv_cmninput"
                        type="datetime-local"
                        placeholder="john@jamkse.com"
                        value={Formdata.ExpireTime ? Formdata.ExpireTime.slice(0, 16) : ""}
                        // disabled={Formdata.ExpireTime}
                        id="ExpireTime"
                        onChange={(e) => OnChange(e)}
                      />
                      {Error?.ExpireTime && (
                        <span className="error-msg">
                          {Error.ExpireTime}
                        </span>
                      )}
                    </Col>
                  )}

                  {Formdata?.Expiry == "day" && (
                    <Col
                      xxl={4}
                      xl={4}
                      lg={4}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-3"
                    >
                      <p className="mdv_inplabel">Select Days</p>
                      <Select
                        isMulti
                        options={Days}
                        styles={stylesgraybg}
                        className="border_blue_select"
                        classNamePrefix="react-select"
                        placeholder="Select Options"
                        onChange={(e) => OnChange(e, "Day", true)}
                        value={Formdata?.Day.map((it) => {
                          return {
                            label: Days?.find((id) => id.value == it)
                              ?.label,
                            value: it,
                          };
                        })}
                      // onChange={(e) => OnChange(e, "Day")}
                      // value={
                      //   Formdata.BuyProductId
                      //     ? {
                      //       label: Days?.find(ig=>ig.value==Formdata.Day)?.label,
                      //       value: Formdata.Day,
                      //     }
                      //     : ""
                      // }
                      // disabled={Formdata.CouponType}
                      />

                      {Error?.Day && (
                        <span className="error-msg">
                          {Error?.Day}
                        </span>
                      )}
                    </Col>
                  )}
                  {console.log("_________________________", Formdata)}
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Coupon Image</p>

                    <div class="flat_upload_img">
                      <img
                        className="flat_cloudimg"
                        src={require("../../../assests/images/cloud.png")}
                        alt="logo_img"
                      />
                      <p class="flat_uploadtxt">Upload Image</p>
                      <input class="flat_uploadfile" type="file"
                        placeholder="Doe"
                        id="CouponImage"
                        onChange={(e) => OnChange(e)} />
                    </div>
                    <p className="mb-0 mt-1">
                      {
                        ImgEmpty(Formdata?.CouponImage)
                          ?
                          "No file uploaded"
                          :
                          (
                            (typeof (Formdata?.CouponImage) == "object")
                              ?
                              Formdata?.CouponImage?.name
                              :
                              (
                                (typeof (Formdata?.CouponImage) == "string")
                                  ?
                                  Formdata?.CouponImage
                                  :
                                  "No file uploaded"
                              )
                          )
                      }
                    </p>


                    {/* <div className="browseinputs position-relative">
                                  <input
                                    className="mdv_cmninput uploadinput"
                                    type="file"
                                    placeholder="Doe"
                                    id="CouponImage"
                                    onChange={(e) => OnChange(e)}
                                  />
                                  <div className="flat_upload_img">
                                    <p className="flat_uploadtxt">Upload Image</p>
                                    </div>
                                 <p className="mb-0">dss sdds</p>
                                  </div> */}

                    {console.log("Idssss", Formdata?.CouponImage)}

                    {Formdata?.CouponImage && (
                      <div className="coupon_img_wrap mt-2">
                        <img
                          src={

                            typeof Formdata?.CouponImage ==
                              "object" ? (
                              window.URL.createObjectURL(
                                Formdata?.CouponImage
                              )
                            ) : (
                              `${config.IMG_URL}/coupon/${Id}/${Formdata?.CouponImage}`
                            )

                          }

                        />
                      </div>

                    )}
                    {Error?.CouponImage && (
                      <span className="error-msg">
                        {Error?.CouponImage}
                      </span>
                    )}
                  </Col>
                  <div className="mdv_update_dualbtn">
                    <button
                      className="blue_btn mdv_update"
                      type="button"
                      onClick={() => Submit()}
                    >
                      Update
                    </button>
                    <button
                      className="seconday_btn"
                      onClick={() => SetFormdata(initname)}
                    >
                      Clear
                    </button>
                  </div>
                </Row>
              </div>
            </div>

            {/* end of change password details */}
          </section>}

    </>
  );
}

export default Coupons;
